module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kyushu-2-319153edf55975a54a75b93a447955c2.jpg";